'use client';

import * as React from 'react';
import { CalendarIcon } from '@radix-ui/react-icons';
import { format } from 'date-fns';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { SelectSingleEventHandler } from 'react-day-picker';

type DatePickerProps = {
  className?: string;
  value: Date | undefined;
  placeholder: string;
  onChange: SelectSingleEventHandler;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
};

export default function DatePicker({
  className,
  value,
  placeholder,
  onChange,
  disabled,
  minDate,
  maxDate,
}: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          className={cn(
            'h-9 w-full justify-between px-3 text-left font-normal',
            !value && 'text-muted-foreground',
            className
          )}
          disabled={disabled}
        >
          <div>{value ? format(value, 'PPP') : <span>{placeholder}</span>}</div>
          <CalendarIcon className='ml-2 h-4 w-4' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0' align='start'>
        <Calendar
          defaultMonth={value || undefined}
          mode='single'
          fromDate={minDate}
          toDate={maxDate}
          selected={value}
          onSelect={onChange}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
